import { render, staticRenderFns } from "./WorkflowStateReminderConfigFormFields.vue?vue&type=template&id=d9a3e69c&"
import script from "./WorkflowStateReminderConfigFormFields.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateReminderConfigFormFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports